export default __webpack_public_path__ + "static/media/swimsuit.db25bc2c.ogg";